import React from 'react';
import {
  Row, Col,
} from 'react-bootstrap';
import { useParams } from 'react-router';
import SuccessComponent from 'components/Success';
import ErrorComponent from 'components/Error';

type ParamTypes = {
  status: string,
};
function Checkout() {
  const { status } = useParams<ParamTypes>();
  return (
    <Row className="">
      <Col md className="mt-5 card--light d-flex align-items-center justify-content-center flex-column">
        {!!status && status === 'success' && (
        <SuccessComponent />
        )}
        {!!status && status !== 'success' && (
        <ErrorComponent error="" />
        )}
      </Col>
    </Row>
  );
}

export default Checkout;
